import { Certificate, GoBackButton } from '@components';
import { useCertificateDownload, useScreenSize, useScrollToTop } from '@hooks';
import { Button, Flex, Typography } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { getDataFromLS } from '../../components/CookiesModal/CookiesModal.propTypes';

const CertificateDownload = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { isTabletLG, isTabletSM } = useScreenSize();
  const language = getDataFromLS('certificateLanguage');
  const name = getDataFromLS('certificateName');
  const { hiddenElementToDownload, onDownload } = useCertificateDownload({
    date: state?.date,
  });

  useScrollToTop();

  const titleByLevel = {
    'Officer Level': 'OfficerLevel',
    'Soldier Level': 'SoldierLevel',
  };

  const title = titleByLevel[state?.title] || state?.title;

  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={32}
      justifyContent="center"
      mt={isTabletSM ? 80 : 140}
      px={isTabletLG ? 16 : 156}
      py={80}
    >
      <GoBackButton />
      <Certificate
        date={state?.date}
        isTablet={isTabletLG}
        language={language}
        name={name}
        size="medium"
        title={title}
      />
      {hiddenElementToDownload}
      <Flex justifyContent="flex-end">
        <Button
          height="69px"
          onClick={onDownload}
          variant="primary"
          width={isTabletSM ? '100%' : '320px'}
        >
          <Typography variant="MS-semibold-s16-lh25">
            {t('Certificate.DownloadPDF')}
          </Typography>
        </Button>
      </Flex>
    </Flex>
  );
};

export default CertificateDownload;
